import {formFieldValue} from '../selectors/formFieldValue';
import formBrand from './formBrand';
import isProject from '../selectors/isProject';

export function formOverridesAjaxUrl(form) {
  if(formBrand(form) === 'vp')
    return `https://${process.env.vpWwwHost}${formFieldValue(form, 'overrideajaxurl')}`;
}

export function formEndpoint(correlationId) {
  if(correlationId) {
    return `/v1/contact/requests?correlationId=${correlationId}`;
  } else {
    return '/v1/contact/requests';
  }
}

export default function(form, correlationId) {
  if(formOverridesAjaxUrl(form)){
    return formOverridesAjaxUrl(form);
  } else {
    // Since iFrame leadforms are built locally, we must use a relative path to ensure
    // the form posts the lead to the correct environment
    const iFrameLeadform = isProject('iframe');
    const endpoint = formEndpoint(correlationId);
    return iFrameLeadform ? endpoint : `https://${process.env.apiHost}${endpoint}`;
  }
}
